module.exports = __webpack_public_path__ + "static/media/sc.b12a9f98.webp";